export enum LOCAL_STORAGE_KEYS {
    ATHENA_EXTENSION_VERSION = 'athena_extension_version',
}

export enum EXTENSION_VERSION {
    VERSION_1 = '1',
    VERSION_2 = '2',
}